import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "redux-store/store";
import { InfiniteScrollKey, LIMIT } from "../const";

const controlInfinitiveScroll = (state: RootState) => state.infinitiveScroll;

export const controlInfinitiveScrollSelector = (
  id: string = InfiniteScrollKey.DEFAULT
) =>
  createSelector(controlInfinitiveScroll, (state) => {
    if (id) {
      return (
        state.controlInfinitiveScrolling[id] ?? {
          offset: 0,
          limit: LIMIT,
        }
      );
    } else {
      return state.controlInfinitiveScrolling[InfiniteScrollKey.DEFAULT];
    }
  });
